import { IonBadge, IonButton, IonCol, IonGrid, IonRow, IonSpinner } from '@ionic/react';
import { useEffect, useState } from 'react';
import { appSubDir } from '../../configs/app';
import Pagination from '../../components/Pagination';
import { fetchAllInvoices, formatedInvoiceId, getAllInvoices, getBadgeColor } from '../../services/account/invoices.service';
import { useHistory } from 'react-router';
import { InvoiceFilterFormData } from '../../types/shop/invoice.type';
import InvoiceFilter from '../../components/Orders/InvoiceFilter';
import AdminLayout from '../../layouts/AdminLayout';
import './AdminPages.scss';

const BDT = new Intl.NumberFormat('en-IN');

const AdminOrdersPage: React.FC = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const response = getAllInvoices({ page: 1 });
    const [filter, setFilter] = useState({ page: 1 } as InvoiceFilterFormData);
    const [lastPage, setLastPage] = useState(0);
    const [items, setItems] = useState(response ? response.data : null);

    useEffect(() => {
        loadInvoices(filter);
    }, []);

    function loadInvoices(filter: InvoiceFilterFormData) {
        const local = getAllInvoices(filter);
        if (local) {
            setItems(local.data);
        } else {
            setLoading(true);
        }
        fetchAllInvoices(filter)
            .then((res) => {
                if (res) {
                    setItems(res.data);
                    setLastPage(res.last_page);
                    setFilter({ ...filter, page: res.current_page });
                }
            })
            .finally(() => setLoading(false));
    }

    function showDetails(id: string) {
        history.push(appSubDir + 'admin/orders/' + id);
    }

    return (
        <AdminLayout title="All Orders">
            <IonGrid>
                <IonRow>
                    <IonCol size="12">
                        {!items && !loading && (
                            <div style={{ textAlign: 'center', padding: '50px' }}>
                                <h2>No Orders Found</h2>
                                <IonButton routerLink={appSubDir} fill="outline">
                                    Go To Home
                                </IonButton>
                            </div>
                        )}

                        {items && (
                            <div>
                                <div className="admin-filter-bar">
                                    <div>
                                        <h3 style={{ margin: 0, color: '#1e293b' }}>
                                            Total: {items.length} order{items.length !== 1 ? 's' : ''}
                                        </h3>
                                    </div>
                                    <InvoiceFilter filter={filter} showAdminFields={true} onChange={loadInvoices} />
                                </div>

                                <div className="admin-table-container">
                                    {loading && (
                                        <div style={{ textAlign: 'center', padding: '30px' }}>
                                            <IonSpinner />
                                        </div>
                                    )}
                                    
                                    {!loading && (
                                        <table className="admin-table">
                                            <thead>
                                                <tr>
                                                    <th>Order ID</th>
                                                    <th className="mobile-invisible">Date</th>
                                                    <th>Total</th>
                                                    <th>Paid</th>
                                                    <th>Due</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {items.map((item, index) => {
                                                    if (item.status)
                                                        return (
                                                            <tr
                                                                style={{ cursor: 'pointer' }}
                                                                key={index}
                                                                onClick={() => showDetails(item.invoice_id)}
                                                            >
                                                                <td className="text-center">{formatedInvoiceId(item.invoice_id)}</td>
                                                                <td className="text-center mobile-invisible">
                                                                    {new Date(Date.parse(item.created_at)).toDateString()}
                                                                </td>
                                                                <td className="text-end">{BDT.format(item.total)}/=</td>
                                                                <td className="text-end">{BDT.format(item.paid)}/=</td>
                                                                <td className="text-end">{item.due ? BDT.format(item.due) : 0}/=</td>
                                                                <td className="text-center">
                                                                    <IonBadge color={getBadgeColor(item.status)}>{item.status}</IonBadge>
                                                                </td>
                                                            </tr>
                                                        );
                                                })}
                                            </tbody>
                                        </table>
                                    )}
                                </div>

                                <div style={{ marginTop: 30 }}>
                                    {lastPage > 1 && (
                                        <Pagination
                                            active={filter.page}
                                            disabled={loading}
                                            onClick={(page: number) => loadInvoices({ ...filter, page })}
                                            buttonCount={lastPage}
                                        />
                                    )}
                                </div>
                            </div>
                        )}
                    </IonCol>
                </IonRow>
            </IonGrid>
        </AdminLayout>
    );
};

export default AdminOrdersPage;
